import { CountUp } from "countup.js";

export default () => {
  const easingFn = function (t, b, c, d) {
    var ts = (t /= d) * t;
    var tc = ts * t;
    return b + c * (tc + -3 * ts + 3 * t);
    }

  const optionsN0 = {
    duration: 4,
    startVal: 1,
    easingFn,
  };
  const optionsN1 = {
    duration: 4,
    startVal: 1,
    suffix: '%',
    easingFn,
  };
  const optionsN2 = {
    duration: 4,
    startVal: 1,
    easingFn,
  };
  const optionsN3 = {
    decimalPlaces: 1,
    duration: 4,
    startVal: 0.1,
    easingFn,
  };
  const optionsN4 = {
    duration: 4,
    startVal: 1,
    easingFn,
  };
  const optionsN5 = {
    duration: 4,
    startVal: 1,
    easingFn,
  };

  const el = document.querySelector(".counters");

  var countUp0 = new CountUp("number0", 5, optionsN0);
  var countUp1 = new CountUp("number1", 3, optionsN1);
  var countUp2 = new CountUp("number2", 100, optionsN2);
  var countUp3 = new CountUp("number3", 1.1, optionsN3);
  var countUp4 = new CountUp("number4", 334, optionsN4);
  var countUp5 = new CountUp("number5", 18, optionsN5);
  const destinationPage = document.querySelector(".page-template-templatestemplate-destination-php");
  if (destinationPage) {
    window.addEventListener("scroll", () => {
      if (window.scrollY + window.outerHeight - 350 > el.offsetTop) {
        console.log("start");
        countUp0.start();
        countUp1.start();
        countUp2.start();
        countUp3.start();
        countUp4.start();
        countUp5.start();
      }
    })
  }
  
  

  // window.addEventListener("scroll", function onScroll() {
  //   numbers.forEach((number) => {
  //     const numberTop = number.getBoundingClientRect().top;
  //     let start = 0;
  //     const end = +number.innerHTML;

  //     if (window.pageYOffset + 200 > numberTop - window.innerHeight / 2 ) {
  //       this.removeEventListener("scroll", onScroll);

  //       if (end < 50 && end > 10) {
  //         var interval = setInterval(function () {
  //           number.innerHTML = ++start;
  //           if (start == end ) {
  //             clearInterval(interval);
  //           }
  //         }, 200);
  //       }
  //       if (end > 50 && end <= 100) {
  //         var interval = setInterval(function () {
  //           number.innerHTML = ++start;
  //           if (start == end) {
  //             clearInterval(interval);
  //           }
  //         }, 20);
  //       }
  //       if (end > 100) {
  //         var interval = setInterval(function () {
  //           number.innerHTML = ++start;
  //           if (start == end ) {
  //             clearInterval(interval);
  //           }
  //         }, 5);
  //       }
  //       if (end > 2 && end < 10)  {
  //           var interval = setInterval(function () {
  //             number.innerHTML = ++start;
  //             if (start == end) {
  //               clearInterval(interval);
  //             }
  //           }, 500);
  //         }
  //     }
  //   });
  // });
};
